import { createSelector } from 'reselect';
import { RootState } from 'src/store/storeManager';

const getCroppingEnableData = (state: RootState) => state.sceneConfiguration.activeLink.cropping.enable;

const getCroppingEnable = createSelector([getCroppingEnableData], (config) => config);

export default getCroppingEnable;
